module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "responsibles"
  }, [(_vm.$auth.user().roles[0].name !== 'project-responsible') ? _c('box-helper', {
    attrs: {
      "headline": "Ansvarlige",
      "identifier": "responsibles"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container section"
  }, [(_vm.$auth.user().roles[0].name !== 'project-responsible') ? _c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Ansvarlige</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Ét samlet overblik over dine ansvarlige\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.$auth.user().roles[0].name !== 'project-responsible') ? _c('content-switch', {
    attrs: {
      "items": _vm.switchItems,
      "selectedItem": _vm.selectedItem,
      "counts": _vm.counts
    },
    on: {
      "selectItem": function($event) {
        return _vm.handleSelectItem($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('compare-responsible-employees', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'compareResponsibleEmployees'),
      expression: "selectedItem === 'compareResponsibleEmployees'"
    }]
  }), _vm._v(" "), _c('compare-project-types-for-responsibles', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'compareProjectTypesForResponsibles'),
      expression: "selectedItem === 'compareProjectTypesForResponsibles'"
    }]
  }), _vm._v(" "), _c('responsible-valuechain', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'responsibleValuechain'),
      expression: "selectedItem === 'responsibleValuechain'"
    }]
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15d9b2d5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsibles/index.vue
// module id = 808
// module chunks = 0